import { Interval, PaymentItemType } from "../const.mjs";
import { z } from "zod";
//#region src/payment/item/promotion.ts
const paymentItemPromotionSchema = z.object({
	source: z.string().optional(),
	lotteryTokens: z.number().optional(),
	decorationCodes: z.array(z.string()).optional(),
	tierRewards: z.array(z.object({
		trackKey: z.string(),
		amount: z.number()
	})).optional(),
	interval: z.enum(Interval).optional()
});
/**
* Minimal item shape required for getting promotions.
* Used by EventPaymentPromotionProvider.getPromotionsForItem()
*/
const promotionApplicableItemSchema = z.object({
	id: z.string(),
	type: z.enum(PaymentItemType)
});
//#endregion
export { paymentItemPromotionSchema, promotionApplicableItemSchema };
